import { useEffect, useState } from "react";
import { cloneDeep } from "lodash";

import CreateRecordButton from "./CreateRecordButton";
import TkDeliveryDetailDialog from "../dialogTypes/TkDeliveryDetailDialog";

function TkDeliveryDetailButton (props) {

    const {id, grid, onSelectMst, refresh, schema, createButtonName, onSuccess, customizeErrorMsgCallback, ...others} = props;
    
    const [ open, setOpen ] = useState(false);

    const [modifiedSchema, setModifiedSchema] = useState();

    useEffect(() => {

        if(schema) {

            let modifiedSchema = cloneDeep(schema);

            let workOrderNumber = {};
            
            workOrderNumber.name = "workOrderNumber";
            
            workOrderNumber.readonly = true;
            workOrderNumber.disabled = true;
            workOrderNumber.formGroup = 0;
            workOrderNumber.formOrder = 1;
            workOrderNumber.formItemType = "text";
            
            modifiedSchema.columns.push (workOrderNumber);
            
            let dueDateColumn = {};
            
            dueDateColumn.name = "dueDate";
            
            dueDateColumn.readonly = true;
            dueDateColumn.disabled = true;
            dueDateColumn.formGroup = 0;
            dueDateColumn.formOrder = 2;
            dueDateColumn.formItemType = "text";
            
            modifiedSchema.columns.push (dueDateColumn);

            let materialNameColumn = {};
            
            materialNameColumn.name = "materialName";
            
            materialNameColumn.readonly = true;
            materialNameColumn.disabled = true;
            materialNameColumn.formGroup = 1;
            materialNameColumn.formOrder = 3;
            materialNameColumn.formItemType = "text";
            
            modifiedSchema.columns.push (materialNameColumn);

            let modelNameColumn = {};
            
            modelNameColumn.name = "modelName";
            
            modelNameColumn.readonly = true;
            modelNameColumn.disabled = true;
            modelNameColumn.formGroup = 0;
            modelNameColumn.formOrder = 4;
            modelNameColumn.formItemType = "text";
            
            modifiedSchema.columns.push (modelNameColumn);

            let modelPartNameColumn = {};
            
            modelPartNameColumn.name = "modelPartName";
            
            modelPartNameColumn.readonly = true;
            modelPartNameColumn.disabled = true;
            modelPartNameColumn.formGroup = 0;
            modelPartNameColumn.formOrder = 5;
            modelPartNameColumn.formItemType = "text";
            
            modifiedSchema.columns.push (modelPartNameColumn);

            let partNoColumn = {};
            
            partNoColumn.name = "partNo";
            
            partNoColumn.readonly = true;
            partNoColumn.disabled = true;
            partNoColumn.formGroup = 1;
            partNoColumn.formOrder = 6;
            partNoColumn.formItemType = "text";
            
            modifiedSchema.columns.push (partNoColumn);

            let partSeqColumn = {};
            
            partSeqColumn.name = "partSeq";
            
            partSeqColumn.readonly = true;
            partSeqColumn.disabled = true;
            partSeqColumn.formGroup = 1;
            partSeqColumn.formOrder = 7;
            partSeqColumn.formItemType = "text";
            
            modifiedSchema.columns.push (partSeqColumn);

            let opCodeColumn = {};
            
            opCodeColumn.name = "opCode";
            
            opCodeColumn.readonly = true;
            opCodeColumn.disabled = true;
            opCodeColumn.formGroup = 1;
            opCodeColumn.formOrder = 8;
            opCodeColumn.formItemType = "text";
            
            modifiedSchema.columns.push (opCodeColumn);

            let cutCode1Column = {};
            
            cutCode1Column.name = "cutCode1";
            
            cutCode1Column.readonly = true;
            cutCode1Column.disabled = true;
            cutCode1Column.formGroup = 1;
            cutCode1Column.formOrder = 9;
            cutCode1Column.formItemType = "text";
            
            modifiedSchema.columns.push (cutCode1Column);

            let cutCode2Column = {};
            
            cutCode2Column.name = "cutCode2";
            
            cutCode2Column.readonly = true;
            cutCode2Column.disabled = true;
            cutCode2Column.formGroup = 1;
            cutCode2Column.formOrder = 10;
            cutCode2Column.formItemType = "text";
            
            modifiedSchema.columns.push (cutCode2Column);

            let itemSpecNameColumn = {};
            
            itemSpecNameColumn.name = "itemSpecName";
            
            itemSpecNameColumn.readonly = true;
            itemSpecNameColumn.disabled = true;
            itemSpecNameColumn.formGroup = 1;
            itemSpecNameColumn.formOrder = 15;
            itemSpecNameColumn.formItemType = "text";
            
            modifiedSchema.columns.push (itemSpecNameColumn);

            let itemUnitNameColumn = {};
            
            itemUnitNameColumn.name = "itemUnitName";
            
            itemUnitNameColumn.readonly = true;
            itemUnitNameColumn.disabled = true;
            itemUnitNameColumn.formGroup = 1;
            itemUnitNameColumn.formOrder = 20;
            itemUnitNameColumn.formItemType = "text";
            
            modifiedSchema.columns.push (itemUnitNameColumn);

            let materialColumn = {};
            
            materialColumn.name = "material";
            
            materialColumn.readonly = true;
            materialColumn.disabled = true;
            materialColumn.formGroup = 1;
            materialColumn.formOrder = 25;
            materialColumn.formItemType = "text";
            
            modifiedSchema.columns.push (materialColumn);

            let deliveryCompanyNameColumn = {};
            
            deliveryCompanyNameColumn.name = "deliveryCompanyName";
            
            deliveryCompanyNameColumn.readonly = true;
            deliveryCompanyNameColumn.disabled = true;
            deliveryCompanyNameColumn.formGroup = 0;
            deliveryCompanyNameColumn.formOrder = 30;
            deliveryCompanyNameColumn.formItemType = "text";
            
            modifiedSchema.columns.push (deliveryCompanyNameColumn);

            let deliveryPlaceColumn = {};
            
            deliveryPlaceColumn.name = "deliveryPlace";
            
            deliveryPlaceColumn.readonly = true;
            deliveryPlaceColumn.disabled = true;
            deliveryPlaceColumn.formGroup = 0;
            deliveryPlaceColumn.formOrder = 35;
            deliveryPlaceColumn.formItemType = "text";
            
            modifiedSchema.columns.push (deliveryPlaceColumn);

            let qtyColumn = {};
            
            qtyColumn.name = "qty";

            qtyColumn.readonly = true;
            qtyColumn.disabled = true;
            qtyColumn.formGroup = 1;
            qtyColumn.formOrder = 40;
            qtyColumn.formItemType = "text";
            
            modifiedSchema.columns.push (qtyColumn);

            setModifiedSchema(modifiedSchema);

        }

    },[schema]);

    const onOpen = () => {

        setOpen ( true );
    };

    const onClose = () => {

        setOpen ( false );

    };

    const onDeliveryDetailSuccess = (msg) => {

        if (onSuccess) {
    
          onSuccess(msg);
    
        }

        refresh.refresh();
    
    };


    return (
        <>
        <CreateRecordButton id = {id+"-detail-button"} onClick = {onOpen} createButtonName ={createButtonName} {...others}/>
        <TkDeliveryDetailDialog
            id={id+"ship-dialog"}
            schema={modifiedSchema}
            onSelectMst = {onSelectMst}
            open={open}
            onClose={onClose}
            onSuccess={onDeliveryDetailSuccess}
        />
        </>
    )

}

export default TkDeliveryDetailButton;